import { Box, Grid2, Typography } from '@mui/material'
import { useAuth } from 'components/AuthProvider'
import Button from 'components/Button'
import { createKidVaultPath, updateKidVaultPath } from 'components/Routes'
import DefaultLayout from 'components/layout/DefaultLayout'
import { useNavigate } from 'react-router-dom'
import { generateUsername } from 'utils/util'
import useStyles from './styles'

export default function KidVault(): JSX.Element {
  const { classes } = useStyles()

  const { user } = useAuth()

  const navigate = useNavigate()

  const vaults = user?.vaults ?? []

  const handleClickVault = (id: string) => {
    navigate(
      updateKidVaultPath({
        routeParams: { id: id }
      })
    )
  }

  const renderCreateButton = () => {
    const handleCreateNewKidVault = () => {
      navigate(createKidVaultPath())
    }

    return (
      <Box className={classes.button}>
        <Button
          color='primary'
          variant='outlined'
          fullWidth
          onClick={handleCreateNewKidVault}
        >
          New kid's vault
        </Button>
      </Box>
    )
  }

  return (
    <DefaultLayout
      wrapperContent={{ mt: 0, mb: 2 }}
      showBackIcon
      heading='Kids Vault'
    >
      <Grid2 container rowSpacing={2} py={4}>
        {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
        {vaults.map((vault: any) => (
          <Grid2 key={vault.id} size={{ xs: 12 }}>
            <Box
              className={classes.kid}
              onClick={() => handleClickVault(vault.id)}
            >
              <Typography>{vault.name || generateUsername(user)}</Typography>
            </Box>
          </Grid2>
        ))}
      </Grid2>
      {renderCreateButton()}
    </DefaultLayout>
  )
}
